<template>
  <v-dialog
    width="600"
    :value="visible"
  >
    <v-card class="container">
      <div class="heading-image">
        <img src="/illustration.svg" />
      </div>

      <v-card-title>
        Getting Started
      </v-card-title>
      <v-card-text>
        <p>This is an example of a reward that your recipient would receive.</p>
        <p>You can customize nearly everything, including the amount, the messaging, and the branding of the reward.</p>
        <p>Explore the experience for yourself.</p>
      </v-card-text>
      <v-card-actions
        class="actions"
      >
        <v-btn
          class="button"
          :color="buttonColor"
          @click="$emit('acknowledged')"
        >
          Let's go!
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { TangoCardColors } from '@tangocard/swag'

export default {
  name: 'DemoDialog',
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    buttonColor () {
      return TangoCardColors.orange_800
    }
  }
}
</script>

<style lang="scss" scoped>
.heading-image {
  background-color: #FECD9C;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 0;

  img {
    max-width: 250px;
  }
}

.actions {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-right: 25px;
}

.button {
  text-transform: none;
  border-radius: 3px;
  padding: 20px !important;
}

.container {
  padding: 0;
  padding-bottom: 16px;
}
</style>
